export default __webpack_public_path__ + "static/media/223.5ca5e3a3.svg";